import React, { useState } from "react";
import PropTypes from "prop-types";

const AnnotationCommentDelete = ({ onClick }) => {
  const [tooltipText, setTooltipText] = useState("Delete");

  const handleClick = (e) => {
    e.stopPropagation();
    onClick();
    setTooltipText("Deleted");
  };

  return (
    <button onClick={handleClick} className="btn btn-link unstyled tooltip-hover">
      <span className="tooltip-text" id="tooltip-top">{tooltipText}</span>
      <i className="grey-text text-darken-1 material-icons align-middle d-inline">delete_outline</i>
    </button>
  );
};

AnnotationCommentDelete.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default AnnotationCommentDelete;
